import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "@/views/public/contact/ContactPage.tsx";

export const Route = createFileRoute("/_public/contact")({
  component: ContactPage,
});
